<!-- recurring payment form -->
<form #form="ngForm" name="formRecurringPayment" id="adyen-encrypted-form" ng novalidate>
  <div
    *ngIf="price.totalPrice?.majorAmount > 0 && !payByInvoice && bookingState.bookingDetails.bookingAmendType !== 'refund' && !overridePayment">
    <div class="panel paymentScreen padding-0 margin-bottom-0">
      <div class="payment_head">

      <span>
        <h5 class="text-dark-blue margin-top-0 margin-bottom-0" *ngIf="bookingType !== 'amend'">
          {{appCopy.panelHeader['paymentHeadTitle'+selectedLanguage]}}</h5>
        <h5 *ngIf="bookingType === 'amend' && bookingState.bookingDetails.bookingAmendType !== 'refund'">
          {{appCopy.panelHeader['paymentHeadTitle'+selectedLanguage]}}
        </h5>
        <h5 *ngIf="bookingType === 'amend' && bookingState.bookingDetails.bookingAmendType === 'refund'">
          {{appCopy.panelHeader['refundLabel'+selectedLanguage]}}</h5>

        <!-- <input (click)="sendPaymentType(1)" name="PaymentType" [(ngModel)]="paymenttype" required #PaymentType="ngModel"
          type="radio" [value]="1" /> Credit Card
        <input (click)="sendPaymentType(0)" name="PaymentType" [(ngModel)]="paymenttype" required #PaymentType="ngModel"
          type="radio" [value]="0" /> Google Pay -->

      </span>
    </div>

      <div class="payment-details fadeIn" *ngIf="selectedCardItem !== 'newCard'">
        <label
          class="control-label control-label--uppercase">{{appCopy.panelHeader['savedCardLabel'+selectedLanguage]}}</label>
        <div *ngFor="let card of userCards; let i = index;" class="panel panel-default margin-bottom-8
          ">
          <div class="radio radio--default radio--small">
            <input type="radio" name="selectedCardItem" id="card{{i}}" [(ngModel)]="selectedCardItem"
              (ngModelChange)="setSelectedCard(card.recurringDetailReference)" [value]="card.recurringDetailReference">
            <label class="text-caption-large" for="card{{i}}">
              <img *ngIf="isPaypalCard(card)" class="margin-right-8" src="./images/PayPal.svg" alt="PayPal" height="20px">
              <i *ngIf="!isPaypalCard(card)" class="sprite-common" [ngClass]="setCardLogo(card.cardType)"></i>
              <div>
                <!-- A PayPal token holds an email address rather than a card
                     number, so it takes neither the star prefix nor the expiry. -->
                <span *ngIf="isPaypalCard(card)">{{ card.number }}</span>
                <span *ngIf="!isPaypalCard(card)">**** **** **** {{ card.number }}</span>
                <div class="fadeIn" *ngIf="selectedCardItem === card.recurringDetailReference">
                  <span *ngIf="!isPaypalCard(card)">{{ card.holderName }}</span>
                  <span
                    *ngIf="!isPaypalCard(card) && selectedCardDetails?.expiryYear"> ({{appCopy.panelHeader['ccExpMonthLabel'+selectedLanguage]}} {{
                    selectedCardDetails.expiryMonth }}/{{
                    selectedCardDetails.expiryYear.slice(-2) }})</span>
                </div>
              </div>
            </label>
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-xs-6">
            <button type="button" class="btn btn-default btn-block"
              (click)="selectedCardItem = 'newCard'">{{appCopy.panelHeader['addNewCard'+selectedLanguage]}}</button>
          </div>
          <div class="col-xs-6">
            <a *ngIf="bookingType !== 'amend'" class="link text-danger pull-right" href="javascript:void(0);"
              (click)="deleteCard(selectedCardItem)">
              {{appCopy.panelHeader['removeCard'+selectedLanguage]}}
            </a>
          </div>
        </div>
      </div>

      <div *ngIf="selectedCardItem === 'newCard'">
        <div class="panel panel-default new-card fadeIn">
          <div class="panel-body">
            <div class="flex-lg flex-md">
              <div class="flex__item--grow">
                <label class="control-label control-label--uppercase"
                  for="ccnumber">{{appCopy.panelHeader['ccNumberLabel'+selectedLanguage]}}</label>
                <div class="form-group">
                  <input class="form-control form-control--no-label"
                    [ngClass]="{ 'has-error' : CardNumber.dirty && CardNumber.invalid }" name="ccnumber" id="ccnumber"
                    type="text" autocomplete="cc-number" maxlength="23" data-encrypted-name="number"
                    #CardNumber="ngModel" [ngModel]='formValues.ccnumber' required appFormatCard appCheckEmpty>
                  <i class="icon control-validation-state"></i>

                  <p class="help-block text-danger" *ngIf="CardNumber.dirty && CardNumber.invalid">
                    {{appCopy.panelHeader['errortextCcNumber'+selectedLanguage]}}</p>
                </div>
              </div>
            </div>

            <div class="flex-lg flex-md card-inputs clearfix">
              <div class="form-group flex__item--grow">
                <input class="form-control" [ngClass]="{ 'has-error' : CardName.dirty && CardName.invalid }"
                  id="nameoncard" name="nameoncard" type="text" autocomplete="cc-name" data-encrypted-name="holderName"
                  #CardName="ngModel" [ngModel]='formValues.nameoncard' required appCheckEmpty>
                <label class="control-label"
                  for="nameoncard">{{appCopy.panelHeader['nameOnCardLabel'+selectedLanguage]}}</label>
                <i class="icon control-validation-state"></i>

                <p class="help-block text-danger" *ngIf="CardName.dirty && CardName.invalid">
                  {{appCopy.panelHeader['errorTextNameOnCardRequired'+selectedLanguage]}}</p>
              </div>

              <div class="form-group">
                <div class="date-inputs">
                  <input class="form-control"
                    [ngClass]="{ 'has-error' : CardExpiryMonth.dirty && CardExpiryMonth.invalid || CardExpiryYear.dirty && CardExpiryYear.invalid }"
                    name="ccexpmonth" id="ccexpmonth" type="number" autocomplete="cc-exp-month" maxlength="2"
                    data-encrypted-name="expiryMonth" placeholder="MM" #CardExpiryMonth="ngModel"
                    [pattern]="expiryMonthPattern" [ngModel]='formValues.ccexpmonth' required [appAutoTab]="2">
                  <div class="date-inputs__separator"></div>
                  <input class="form-control"
                    [ngClass]="{ 'has-error' : CardExpiryMonth.dirty && CardExpiryMonth.invalid || CardExpiryYear.dirty && CardExpiryYear.invalid }"
                    name="ccexpyear" id="ccexpyear" type="number" autocomplete="cc-exp-year" maxlength="2"
                    data-encrypted-name="expiryYear"
                    [placeholder]="appCopy.panelHeader['yearPlaceholder'+selectedLanguage]" #CardExpiryYear="ngModel"
                    [pattern]="expiryYearPattern" [ngModel]='formValues.ccexpyear' required appCheckEmpty>
                  <label class="control-label control-label--fixed" for="ccexpmonth">{{appCopy.panelHeader['ccExpMonthLabel'+selectedLanguage]}}</label>
                  <i class="icon control-validation-state"></i>
                </div>
                <p class="help-block text-danger"
                  *ngIf="CardExpiryMonth.dirty && CardExpiryMonth.invalid || CardExpiryYear.dirty && CardExpiryYear.invalid">
                  {{appCopy.panelHeader['errorTextCcExpMonthLabel'+selectedLanguage]}}</p>
              </div>
              <div class="form-group">
                <input class="form-control"
                  [ngClass]="{ 'has-error' : CardSecurityCode.dirty && CardSecurityCode.invalid }"
                  name="CardSecurityCode" id="CardSecurityCode" type="text" maxlength="4" autocomplete="nope"
                  data-encrypted-name="cvc" #CardSecurityCode="ngModel" [pattern]="cardSecurityPattern" [ngModel]='formValues.CardSecurityCode' required
                  appCheckEmpty>
                <label class="control-label"
                  for="CardSecurityCode">{{appCopy.panelHeader['cardSecurityCodeLabel'+selectedLanguage]}}</label>
                <i class="icon control-validation-state"></i>
                <p class="help-block text-danger"
                  *ngIf="CardSecurityCode.dirty && CardSecurityCode.invalid && !CardSecurityCode.errors?.pattern">
                  {{appCopy.panelHeader['errorTextCardSecurityCodeRequired'+selectedLanguage]}}</p>
                <p class="help-block text-danger" *ngIf="CardSecurityCode.dirty && CardSecurityCode.errors?.pattern">
                  {{appCopy.panelHeader['errorTextCardSecurityCodeInvalid'+selectedLanguage]}}</p>
              </div>
            </div>

            <input type="hidden" value="generate-this-server-side" data-encrypted-name="generationtime">

            <p class="help-block text-danger" *ngIf="paymentError">
              {{appCopy.panelHeader['errortextPaymentError'+selectedLanguage]}}</p>

            <div class="flex-lg flex-md flex-sm margin-top-16">
              <div class="flex__item--equal checkbox checkbox--default checkbox--small margin-top-16 margin-bottom-16"
                *ngIf="bookingType !== 'amend'">
                <input type="checkbox" (change)="clickSaveCard($event)" name="saveCard" id="saveCard"
                  #saveCard="ngModel" [ngModel]="false">
                <label for="saveCard">{{appCopy.panelHeader['saveCardCheckLabel'+selectedLanguage]}}</label>
              </div>
            </div>

          </div>
        </div>

        <div class="row" >
          <div class="col-xs-6" *ngIf="selectedCardItem === 'newCard' && userCards.length > 0">
            <button type="button" class="btn btn-default btn-block"
              (click)="useSaveCard()">{{appCopy.panelHeader['useSavedCardLabel'+selectedLanguage]}}</button>
          </div>
        </div>


        <div class="row" *ngIf="!isCustomerSupport">
          <div class="col-sm-12 padding-0">
            <h5 class="margin-top-12">{{appCopy.panelHeader['billingAddressLabel'+selectedLanguage]}}</h5>
            <div class="panel panel-default new-card visible-overflow">
              <div class="panel-body">
                <div *ngIf="billingAddress" class="checkbox checkbox--default checkbox--small margin-top-0" [ngClass]="{'margin-bottom-0': hasBillingAddress, 'margin-bottom-12': !hasBillingAddress}" >
                  <input type="checkbox" name="hasBillingAddress" id="hasBillingAddress" [checked]="hasBillingAddress"
                    (change)="toggleBillingAddress()" required>
                  <label for="hasBillingAddress" class="text-caption">
                    <div>
                      <span
                        *ngIf="billingAddressSame">{{appCopy.panelHeader['helperTextBillingAddressSame'+selectedLanguage]}}<br></span>
                      <strong>
                        {{ billingAddress.houseNumberOrName }}, {{ billingAddress.street }}, {{ billingAddress.city }}, {{
                        billingAddress.postalCode }}
                      </strong>
                    </div>
                  </label>
                </div>
                <div *ngIf="!hasBillingAddress">
                  <app-billing-address #billingAddressForm [billingAddressValid]="billingAddressValid" [appCopy]="appCopy"
                    [selectedLanguage]='selectedLanguage' [formData]='formValues.billingFormData'>
                  </app-billing-address>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</form>
